// extracted by mini-css-extract-plugin
export var circle = "_bw-1";
export var exitConfirmationModal = "_bw-5";
export var iframe = "_bw-0";
export var offline = "_bw-3";
export var online = "_bw-2";
export var workstationSelectError = "_bw-4";